import React, { useEffect, useState } from "react";
// import { useEffect } from "react";
import GitHubCalendar from "react-github-calendar";
import { AiFillHtml5 } from "react-icons/ai";
import { BiGitRepoForked } from "react-icons/bi";
import { BsCheckAll, BsFront } from "react-icons/bs";
import { CgToolbox } from "react-icons/cg";
import { FaNodeJs, FaServer } from "react-icons/fa";
import { FiUsers } from "react-icons/fi";
import { IoIosArrowForward } from "react-icons/io";
import { FaWordpress } from "react-icons/fa";
import { FaElementor } from "react-icons/fa6";
import {
    SiApachejmeter,
    SiCss3,
    SiExpress,
    SiFigma,
    SiFirebase,
    SiGithub,
    SiGooglechrome,
    SiGooglefonts,
    SiJavascript,
    SiJsonwebtokens,
    SiMongodb,
    SiNeovim,
    SiNetlify,
    SiPostman,
    SiReact,
    SiReactrouter,
    SiSelenium,
    SiTestcafe,
    SiVercel,
    SiVisualstudiocode
} from "react-icons/si";
import { TbApi, TbBrandCypress } from "react-icons/tb";
// import "react-sweet-progress/lib/style.css";
// import gutuhab from "../../gutuhab/gutuhab";
            
const Skills = () => {

    const [showBox, setShowBox] = useState(false);
    const handleSeeMoreClick = () => {
        setShowBox(true);
    };

    const [details, setDetails] = useState([]);
    useEffect(() => {
    fetch(`https://api.github.com/users/nabilAhmedN`)
    .then((res) => res.json())
    .then((json) => setDetails(json));
    }, []);

    return (
        <div className="mt-28 mb-20 mx-auto">
            {/* Skill head start */}
            <div className="text-center">
                <h2 className="font-extrabold uppercase text-4xl dark:text-[#E9F8F9]">
                    Skills
                </h2>
                <p className="dark:text-[#E9F8F9]">
                    ./ <span className="underline">skills</span>|
                </p>
            </div>
            {/* Skill head end */}

            {/* Coding Skills components start */}
            <div className="mt-24 px-2 md:px-6 w-[100%] lg:w-full mx-auto">
                {/* Coding Skills */}
                <div className="mt-16 w-full">
                    <h2 className="font-bold text-xl dark:text-[#E9F8F9]">
                        Coding Skills
                    </h2>

                    <div className="grid grid-cols-1 gap-8 mt-8 xl:mt-12 xl:gap-12 md:grid-cols-2 xl:grid-cols-3">

                        {/* FrontEnd Technology start */}
                        <div className="p-3 space-y-3 border-2 border-[#98A8F8] dark:border-[#d7f8f5] rounded-xl">
                            <span className="inline-block text-[#98A8F8] dark:text-[#d7f8f5]">
                                <BsFront className="w-8 h-8"></BsFront>
                            </span>

                            <h1 className="text-2xl font-semibold text-gray-700 capitalize dark:text-[#E9F8F9]">
                                FrontEnd Technology
                            </h1>

                            <div className="flex justify-between items-center gap-1">
                                <ul className="text-gray-500">
                                    <li className="flex mt-2 items-center gap-1">
                                        <AiFillHtml5 className="w-6 h-6"></AiFillHtml5>{" "}
                                        HTML5
                                    </li>
                                    <li className="flex mt-2 items-center gap-1">
                                        <SiCss3 className="w-6 h-6"></SiCss3>{" "}
                                        CSS3
                                    </li>
                                    <li className="flex mt-2 items-center gap-1">
                                        <SiJavascript className="w-6 h-6"></SiJavascript>{" "}
                                        JavaScript
                                    </li>
                                    <li className="flex mt-2 items-center gap-1">
                                        <FaWordpress className="w-6 h-6"/>
                                        Wordpress
                                    </li>
                                </ul>
                                <ul className="text-gray-500">
                                    <li className="flex mt-2 items-center gap-1">
                                        <SiReact className="w-6 h-6"></SiReact>{" "}
                                        React JS
                                    </li>
                                    <li className="flex mt-2 items-center gap-1">
                                        <SiReactrouter className="w-6 h-6"></SiReactrouter>{" "}
                                        React Router
                                    </li>
                                    <li className="flex mt-2 items-center gap-1">
                                        <SiFirebase className="w-6 h-6"></SiFirebase>{" "}
                                        Firebase
                                    </li>
                                    <li className="flex mt-2 items-center gap-1">
                                        <FaElementor className="w-6 h-6"/>
                                        Elementor
                                    </li>
                                    
                                </ul>
                            </div>
                        </div>
                        {/* FrontEnd Technology end */}

                        {/* COM: BackEnd Technology start */}
                        <div className="p-4 space-y-3 border-2 border-[#98A8F8] dark:border-[#DEFCF9] rounded-xl">
                            <span className="inline-block text-[#98A8F8] dark:text-[#DEFCF9]">
                                <FaServer className="w-8 h-8 "></FaServer>
                            </span>
                            <h1 className="text-2xl font-semibold text-gray-700 capitalize dark:text-[#E9F8F9]">
                                BackEnd Technology
                            </h1>
                            <div className="flex justify-between items-center gap-3">
                                <ul className="text-gray-500">
                                    <li className="flex mt-2 items-center gap-1">
                                        <SiMongodb className="w-6 h-6 "></SiMongodb>{" "}
                                        MongoDB
                                    </li>
                                    <li className="flex mt-2 items-center gap-1">
                                        <FaNodeJs className="w-6 h-6"></FaNodeJs>{" "}
                                        Node.JS
                                    </li>
                                    <li className="flex mt-2 items-center gap-1">
                                        <SiExpress className="w-6 h-6"></SiExpress>{" "}
                                        Express.JS
                                    </li>
                                </ul>
                                <ul className="text-gray-500">
                                    <li className="flex mt-2 items-center gap-1">
                                        <TbApi className="w-6 h-6"></TbApi> API
                                    </li>
                                    <li className="flex mt-2 items-center gap-1">
                                        <SiVercel className="w-6 h-6"></SiVercel>{" "}
                                        Vercel
                                    </li>
                                    <li className="flex mt-2 items-center gap-1">
                                        <SiJsonwebtokens className="w-6 h-6"></SiJsonwebtokens>{" "}
                                        JsonWebToken
                                    </li>
                                </ul>
                            </div>
                        </div>
                        {/* BackEnd Technology end */}

                        {/* Tools I use start */}
                        <div className="p-4 space-y-3 border-2 border-[#98A8F8] dark:border-[#DEFCF9] rounded-xl">
                            <span className="inline-block text-[#98A8F8] dark:text-[#DEFCF9]">
                                <CgToolbox className="w-8 h-8"></CgToolbox>
                            </span>

                            <h1 className="text-2xl font-semibold text-gray-700 capitalize dark:text-[#E9F8F9]">
                                Tools I use
                            </h1>

                            <div className="flex justify-between items-center">
                                <ul className="text-gray-500">
                                    <li className="flex mt-2 items-center gap-2">
                                        <SiVisualstudiocode className="w-6 h-6"></SiVisualstudiocode>{" "}
                                        VS Code
                                    </li>
                                    <li className="flex mt-2 items-center gap-2">
                                        <SiGithub className="w-6 h-6"></SiGithub>{" "}
                                        Github
                                    </li>
                                    <li className="flex mt-2 items-center gap-2">
                                        <SiGooglechrome className="w-6 h-6"></SiGooglechrome>{" "}
                                        Dev Tool
                                    </li>
                                    <li className="flex mt-2 items-center gap-2">
                                        <SiPostman className="w-6 h-6"></SiPostman>{" "}
                                        Postman
                                    </li>
                                </ul>
                                <ul className="text-gray-500 ">
                                    <li className="flex mt-2 items-center gap-2">
                                        <SiNetlify className="w-6 h-6"></SiNetlify>{" "}
                                        Netlify
                                    </li>
                                    <li className="flex mt-2 items-center gap-2">
                                        <SiFigma className="w-6 h-6"></SiFigma>{" "}
                                        Figma
                                    </li>
                                    <li className="flex mt-2 items-center gap-2">
                                        <SiGooglefonts className="w-6 h-6"></SiGooglefonts>{" "}
                                        Google Fonts
                                    </li>
                                    
                                    <li className="flex mt-2 items-center gap-2">
                                        <SiNeovim className="w-6 h-6"></SiNeovim>{" "}
                                        Neovim
                                    </li>
                                </ul>
                            </div>
                        </div>
                        {/* Tools I use start */}
                    </div>
                </div>
                {/* Coding Skills components end */}

                {/* See more Skills components start */}
                <div className="mt-8">
                    {!showBox ? (
                        <div className="text-center">
                            <button onClick={handleSeeMoreClick} className="group text-white w-fit px-8 py-3  mx-auto flex items-center rounded-md bg-gradient-to-r from-[#7286D3] to-[#8EA7E9] cursor-pointer">
                                See More
                            <span className="group-hover:rotate-90 duration-300">
                            {" "}
                            <IoIosArrowForward size={18} />{" "}
                        </span>
                    </button>
                        </div>
                    ) : (
                        <div className="grid grid-cols-1 gap-8 xl:mt-12 xl:gap-12 md:grid-cols-2 xl:grid-cols-3">

                {/* SQA Technology start */}
                    <div className="p-3 space-y-3 border-2 border-[#98A8F8] dark:border-[#d7f8f5] rounded-xl">
                        <span className="inline-block text-[#98A8F8] dark:text-[#d7f8f5]">
                            <SiTestcafe className="w-8 h-8"></SiTestcafe>
                        </span>

                        <h1 className="text-2xl font-semibold text-gray-700 capitalize dark:text-[#E9F8F9]">
                            SQA
                        </h1>

                        <div className="flex justify-between items-center gap-1">
                            <ul className="text-gray-500">
                                <li className="flex mt-2 items-center gap-1">
                                    <SiSelenium className="w-5 h-5"></SiSelenium>{" "}
                                    Selenium
                                </li>
                                <li className="flex mt-2 items-center gap-1">
                                    <TbBrandCypress className="w-6 h-6"></TbBrandCypress>{" "}
                                    Cypress
                                </li>
                            </ul>
                            <ul className="text-gray-500">
                                <li className="flex mt-2 items-center gap-1">
                                    <SiApachejmeter className="w-8 h-8"></SiApachejmeter>{" "}
                                    JMeter
                                </li>
                                <li className="flex mt-2 items-center gap-1">
                                    <SiPostman className="w-6 h-6"></SiPostman>{" "}
                                    Postman
                                </li>
                            </ul>
                        </div>
                    </div>
                {/* SQA Technology end */}
                </div>
                    )}
                </div>

                {/* See more Skills components end */}
                
                {/* Knowledge component start */}
                <div className="mt-16 ">
                    <h2 className="font-bold text-xl dark:text-[#E9F8F9]">
                        Knowledge
                    </h2>

                    <div className="mt-5 grid grid-cols-1 md:grid-cols-2">
                        <div className="flex items-center text-sm py-1">
                            <BsCheckAll className="text-[#98A8F8] dark:text-emerald-400 mr-3 text-2xl" />
                            <p className="text-lg dark:text-gray-500 ">
                                Responsive Web Design
                            </p>
                        </div>
                        <div className="flex items-center text-sm py-1">
                            <BsCheckAll className="text-[#98A8F8] dark:text-emerald-400 mr-3 text-2xl" />
                            <p className="text-lg dark:text-gray-500 ">
                                Mern Stack Web Development
                            </p>
                        </div>
                        <div className="flex items-center text-sm py-1">
                            <BsCheckAll className="text-[#98A8F8] dark:text-emerald-400 mr-3 text-2xl" />
                            <p className="text-lg dark:text-gray-500 ">
                                Frontend Web Development
                            </p>
                        </div>
                        <div className="flex items-center text-sm py-1">
                            <BsCheckAll className="text-[#98A8F8] dark:text-emerald-400 mr-3 text-2xl" />
                            <p className="text-lg dark:text-gray-500 ">
                                Full Stack Web Development
                            </p>
                        </div>
                        <div className="flex items-center text-sm py-1">
                            <BsCheckAll className="text-[#98A8F8] dark:text-emerald-400 mr-3 text-2xl" />
                            <p className="text-lg dark:text-gray-500 ">
                                Quick learner
                            </p>
                        </div>
                        <div className="flex items-center text-sm py-1">
                            <BsCheckAll className="text-[#98A8F8] dark:text-emerald-400 mr-3 text-2xl" />
                            <p className="text-lg dark:text-gray-500 ">
                            WordPress Developer
                            </p>
                        </div>
                        <div className="flex items-center text-sm py-1">
                            <BsCheckAll className="text-[#98A8F8] dark:text-emerald-400 mr-3 text-2xl" />
                            <p className="text-lg dark:text-gray-500 ">
                                Software Quality Assurance and testing
                            </p>
                        </div>
                    </div>
                </div>
                {/* Knowledge component end */}
  
                {/* Github calendar component  start*/}
                <div className="mt-16 ">
                    <h2 className="font-bold text-xl dark:text-[#E9F8F9]">
                        Days I Code
                    </h2>

                    {/* profile details start */}
                    <div className="flex justify-center items-center gap-2 mb-2">
                        <p className="font-light dark:text-gray-200 text-gray-800 text-sm tracking-wider text-center flex justify-center items-center gap-1">
                            <FiUsers />{" "}
                            <span className="text-sky-600 font-semibold">
                            {details?.followers}
                            </span>{" "}
                            Followers
                        </p>

                        <p className="dark:text-gray-200 text-gray-800"> | </p>

                        <p className="font-light dark:text-gray-200 text-gray-800 text-sm tracking-wider text-center flex justify-center items-center gap-1">
                            <FiUsers />{" "}
                            <span className="text-sky-600 font-semibold">
                            {details?.following}
                            </span>{" "}
                            Following
                        </p>

                        <p className="dark:text-gray-200 text-gray-800"> | </p>

                        <p className="font-light dark:text-gray-200 text-gray-800 text-sm tracking-wider text-center flex justify-center items-center gap-1">
                            <BiGitRepoForked />{" "}
                            <span className="text-sky-600 font-semibold">
                            {details?.public_repos}
                            </span>{" "}
                            repo
                        </p>
                    </div>
                    {/* profile details end */}

                    <div className="mt-6 dark:text-[#E9F8F9]">
                        <GitHubCalendar
                            username="nabilahmedn"
                            blockSize={15}
                            blockMargin={5}
                            fontSize={16}
                        />
                    </div>
                </div>
                {/* Github calendar component end*/}
            </div>
        </div>
    );
};

export default Skills;
